<template>
    <router-view class="content"></router-view>
</template>
<script>
export default {
    data() {
        return {}
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/component/content.vue